import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function ResearchDevelopment() {
  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-20 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/52d3c9f62218a7e85597bbbf50746d57.jpg)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">研究・開発</h1>
          <p className="text-lg md:text-xl mb-8 opacity-95">
            幹細胞培養技術とエクソソーム（エキソソーム）研究の最前線
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-teal-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-800">
              エクソソーム（エキソソーム）研究開発の取り組み
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Exosome Oneは、幹細胞由来エクソソーム（エキソソーム）の基礎研究から応用開発まで、
              包括的な研究開発活動を展開しています。
            </p>
          </div>

          {/* Research Areas */}
          <div className="grid md:grid-cols-3 gap-8 mb-20">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-microscope-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-center text-gray-800">基礎研究</h3>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>幹細胞の分化メカニズム解明</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>エクソソーム（エキソソーム）機能の詳細分析</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>細胞間コミュニケーション研究</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>培養環境最適化の実証</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-test-tube-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-center text-gray-800">応用研究</h3>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>新規治療法の開発</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>疾患モデルでの有効性評価</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>臨床応用に向けた安全性試験</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>バイオマーカーの探索</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-robot-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-center text-gray-800">技術開発</h3>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>自動培養システムの改良</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>AI による品質管理技術</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>無血清培地の開発</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>3D培養技術の確立</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Research Process */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-20">
            <h3 className="text-2xl font-bold mb-8 text-center text-gray-800">研究開発プロセス</h3>
            
            <div className="grid md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">1</span>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">基礎実験</h4>
                <p className="text-sm text-gray-600">
                  細胞の基本特性解析と培養条件の最適化
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">2</span>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">プロトコール開発</h4>
                <p className="text-sm text-gray-600">
                  標準化された培養手順の確立と検証
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">3</span>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">効果検証</h4>
                <p className="text-sm text-gray-600">
                  前臨床試験での安全性と有効性の評価
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">4</span>
                </div>
                <h4 className="font-bold mb-3 text-gray-800">実用化</h4>
                <p className="text-sm text-gray-600">
                  臨床応用に向けた技術移転と量産化
                </p>
              </div>
            </div>
          </div>

          {/* Current Projects */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h3 className="text-2xl font-bold mb-6 text-gray-800">現在の主要研究プロジェクト</h3>
              
              <div className="space-y-6">
                <div className="border-l-4 border-teal-500 pl-6">
                  <h4 className="font-bold text-lg mb-2 text-gray-800">神経疾患治療研究</h4>
                  <p className="text-sm text-gray-600 mb-2">
                    パーキンソン病やアルツハイマー病に対する幹細胞治療の効果検証
                  </p>
                  <span className="text-xs text-teal-600 font-medium">進行中 - フェーズII</span>
                </div>
                
                <div className="border-l-4 border-blue-500 pl-6">
                  <h4 className="font-bold text-lg mb-2 text-gray-800">心血管再生医療</h4>
                  <p className="text-sm text-gray-600 mb-2">
                    心筋梗塞後の心機能回復を目的とした細胞治療法の開発
                  </p>
                  <span className="text-xs text-blue-600 font-medium">進行中 - 前臨床試験</span>
                </div>
                
                <div className="border-l-4 border-purple-500 pl-6">
                  <h4 className="font-bold text-lg mb-2 text-gray-800">がん免疫療法</h4>
                  <p className="text-sm text-gray-600 mb-2">
                    免疫細胞の機能強化によるがん治療効果の向上
                  </p>
                  <span className="text-xs text-purple-600 font-medium">計画中 - 基礎研究</span>
                </div>
              </div>
            </div>
            
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Advanced%20medical%20research%20laboratory%20with%20scientists%20conducting%20stem%20cell%20experiments%20for%20neurological%20disease%20treatment%2C%20researchers%20analyzing%20heart%20tissue%20regeneration%20using%20cell%20therapy%2C%20modern%20biotechnology%20facility%20with%20sophisticated%20microscopes%20and%20cell%20culture%20equipment%2C%20clean%20sterile%20environment%20with%20blue%20LED%20lighting%20and%20temperature%20controlled%20incubators%2C%20medical%20professionals%20developing%20breakthrough%20therapies%20for%20cancer%20immunotherapy%20and%20cardiovascular%20regenerative%20medicine&width=600&height=400&seq=medical-research-projects-2024&orientation=landscape"
                alt="研究プロジェクト"
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
            </div>
          </div>

          {/* Achievements */}
          <div className="bg-gradient-to-br from-teal-600 to-blue-600 text-white rounded-2xl p-8 md:p-12 mb-20">
            <h3 className="text-2xl font-bold mb-8 text-center">研究成果</h3>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">25+</div>
                <p className="text-sm opacity-90">発表論文数</p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">8</div>
                <p className="text-sm opacity-90">取得特許数</p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">12</div>
                <p className="text-sm opacity-90">共同研究機関数</p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">150+</div>
                <p className="text-sm opacity-90">研究開発投資（百万円）</p>
              </div>
            </div>
          </div>

          {/* Future Vision */}
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-6 text-gray-800">Exosome Oneの研究開発の強み</h3>
            <p className="text-lg text-gray-700 max-w-4xl mx-auto mb-8">
              Exosome Oneは、基礎研究から臨床応用まで一貫した研究開発体制により、
              再生医療の社会実装を加速させ、多くの患者さんに新しい治療選択肢を提供することを目指しています。
            </p>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white rounded-lg p-6 shadow-md">
                <i className="ri-global-line text-3xl text-teal-600 mb-4"></i>
                <h4 className="font-bold mb-3 text-gray-800">国際連携強化</h4>
                <p className="text-sm text-gray-600">
                  世界トップクラスの研究機関との連携による技術革新の促進
                </p>
              </div>
              
              <div className="bg-white rounded-lg p-6 shadow-md">
                <i className="ri-cpu-line text-3xl text-blue-600 mb-4"></i>
                <h4 className="font-bold mb-3 text-gray-800">AI技術統合</h4>
                <p className="text-sm text-gray-600">
                  人工知能を活用した培養プロセスの最適化と予測モデルの構築
                </p>
              </div>
              
              <div className="bg-white rounded-lg p-6 shadow-md">
                <i className="ri-heart-pulse-line text-3xl text-purple-600 mb-4"></i>
                <h4 className="font-bold mb-3 text-gray-800">個別化医療</h4>
                <p className="text-sm text-gray-600">
                  患者個人の特性に合わせたオーダーメイド治療法の開発
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}